// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={140}
    height={100}
    viewBox="0 0 140 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M100.5 42.9062H24V38.4062C24 37.2128 24.4741 36.0682 25.318 35.2242C26.1619 34.3803 27.3065 33.9063 28.5 33.9063H96C97.1935 33.9063 98.3381 34.3803 99.182 35.2242C100.026 36.0682 100.5 37.2128 100.5 38.4062V42.9062Z"
      fill="#FFB743"
    />
    <path
      d="M100.799 42.9062H24.2988V38.4062C24.2988 37.2128 24.7729 36.0682 25.6168 35.2242C26.4607 34.3803 27.6054 33.9063 28.7988 33.9063H96.2988C97.4923 33.9063 98.6369 34.3803 99.4808 35.2242C100.325 36.0682 100.799 37.2128 100.799 38.4062V42.9062Z"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M96.2988 94.668H28.7988C27.6054 94.668 26.4607 94.1939 25.6168 93.35C24.7729 92.5061 24.2988 91.3614 24.2988 90.168V42.918H100.799V90.168C100.799 91.3614 100.325 92.5061 99.4808 93.35C98.6369 94.1939 97.4923 94.668 96.2988 94.668Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M57.3398 52.416H34.8398C33.5972 52.416 32.5898 53.4234 32.5898 54.666V83.916C32.5898 85.1587 33.5972 86.166 34.8398 86.166H57.3398C58.5825 86.166 59.5898 85.1587 59.5898 83.916V54.666C59.5898 53.4234 58.5825 52.416 57.3398 52.416Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M88.8399 65.918H68.5898C67.3472 65.918 66.3398 66.9253 66.3398 68.168V83.918C66.3398 85.1606 67.3472 86.168 68.5898 86.168H88.8399C90.0825 86.168 91.0899 85.1606 91.0899 83.918V68.168C91.0899 66.9253 90.0825 65.918 88.8399 65.918Z"
      fill="#FFE9A4"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M66.5479 52.8711H91.5479"
      stroke="#29292F"
    />
    <path
      d="M66.5479 60.5625H91.5479"
      stroke="#29292F"
    />
    <path
      d="M66.5479 56.7207H91.5479"
      stroke="#29292F"
    />
    <path
      d="M12 19.2449L12.4342 19.2601C14.1754 19.324 15.8201 20.0769 17.0063 21.3531C18.1926 22.6294 18.8235 24.3245 18.7601 26.0658L18.7428 26.5L18.7601 26.0658C18.7915 25.2035 18.9924 24.3559 19.3514 23.5713C19.7104 22.7866 20.2205 22.0805 20.8525 21.493C21.4845 20.9056 22.226 20.4484 23.0348 20.1476C23.8435 19.8468 24.7036 19.7082 25.5658 19.7399L26 19.7572L25.5658 19.7399C24.7035 19.7085 23.8559 19.5076 23.0713 19.1486C22.2867 18.7896 21.5805 18.2795 20.993 17.6475C20.4056 17.0155 19.9484 16.274 19.6476 15.4652C19.3468 14.6565 19.2082 13.7964 19.2399 12.9342L19.2551 12.5L19.2399 12.9342C19.2085 13.7965 19.0076 14.6441 18.6486 15.4287C18.2896 16.2133 17.7795 16.9195 17.1475 17.507C16.5155 18.0944 15.774 18.5516 14.9652 18.8524C14.1565 19.1532 13.2964 19.2918 12.4342 19.2601L12 19.2449Z"
      fill="white"
      stroke="#29292F"
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M34 21.3178L34.3101 21.3287C35.5539 21.3743 36.7286 21.912 37.576 22.8237C38.4233 23.7353 38.8739 24.9461 38.8287 26.1899L38.8163 26.5L38.8287 26.1899C38.8511 25.574 38.9946 24.9685 39.251 24.408C39.5075 23.8476 39.8718 23.3432 40.3232 22.9236C40.7746 22.504 41.3043 22.1774 41.882 21.9626C42.4596 21.7477 43.074 21.6487 43.6899 21.6713L44 21.6837L43.6899 21.6713C43.074 21.6489 42.4685 21.5054 41.9081 21.249C41.3476 20.9925 40.8432 20.6282 40.4236 20.1768C40.004 19.7254 39.6774 19.1957 39.4626 18.618C39.2477 18.0404 39.1487 17.426 39.1714 16.8101L39.1822 16.5L39.1714 16.8101C39.149 17.426 39.0054 18.0315 38.749 18.592C38.4925 19.1524 38.1282 19.6568 37.6768 20.0764C37.2254 20.496 36.6957 20.8226 36.118 21.0375C35.5404 21.2523 34.926 21.3513 34.3101 21.3287L34 21.3178Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M9 39.8725L9.21709 39.8801C10.0877 39.912 10.91 40.2884 11.5032 40.9266C12.0963 41.5647 12.4117 42.4123 12.3801 43.2829L12.3714 43.5L12.3801 43.2829C12.3957 42.8518 12.4962 42.4279 12.6757 42.0356C12.8552 41.6433 13.1103 41.2902 13.4263 40.9965C13.7423 40.7028 14.113 40.4742 14.5174 40.3238C14.9217 40.1734 15.3518 40.1041 15.7829 40.1199L16 40.1286L15.7829 40.1199C15.3518 40.1043 14.9279 40.0038 14.5356 39.8243C14.1433 39.6448 13.7902 39.3897 13.4965 39.0737C13.2028 38.7577 12.9742 38.387 12.8238 37.9826C12.6734 37.5783 12.6041 37.1482 12.6199 36.7171L12.6275 36.5L12.6199 36.7171C12.6043 37.1482 12.5038 37.5721 12.3243 37.9644C12.1448 38.3567 11.8897 38.7098 11.5737 39.0035C11.2577 39.2972 10.887 39.5258 10.4826 39.6762C10.0783 39.8266 9.64822 39.8959 9.21709 39.8801L9 39.8725Z"
      fill="white"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M125.5 25.5H49V21C49 19.8065 49.4741 18.6619 50.318 17.818C51.1619 16.9741 52.3065 16.5 53.5 16.5H121C122.193 16.5 123.338 16.9741 124.182 17.818C125.026 18.6619 125.5 19.8065 125.5 21V25.5Z"
      fill="#FFB743"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M121 77.2519H53.5C52.3065 77.2519 51.1619 76.7779 50.318 75.9339C49.4741 75.09 49 73.9454 49 72.7519V25.502H125.5V72.7519C125.5 73.9454 125.026 75.09 124.182 75.9339C123.338 76.7779 122.193 77.2519 121 77.2519Z"
      fill="#F9F9F9"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M111.998 23.25C113.241 23.25 114.248 22.2426 114.248 21C114.248 19.7574 113.241 18.75 111.998 18.75C110.755 18.75 109.748 19.7574 109.748 21C109.748 22.2426 110.755 23.25 111.998 23.25Z"
      fill="#29292F"
    />
    <path
      d="M118.749 23.25C119.992 23.25 120.999 22.2426 120.999 21C120.999 19.7574 119.992 18.75 118.749 18.75C117.506 18.75 116.499 19.7574 116.499 21C116.499 22.2426 117.506 23.25 118.749 23.25Z"
      fill="#29292F"
    />
    <path
      d="M82.748 34.502H60.248C59.0054 34.502 57.998 35.5093 57.998 36.752V66.002C57.998 67.2446 59.0054 68.252 60.248 68.252H82.748C83.9907 68.252 84.998 67.2446 84.998 66.002V36.752C84.998 35.5093 83.9907 34.502 82.748 34.502Z"
      fill="#F9F9F9"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M114.248 48.0029H93.998C92.7554 48.0029 91.748 49.0103 91.748 50.2529V66.0029C91.748 67.2456 92.7554 68.2529 93.998 68.2529H114.248C115.491 68.2529 116.498 67.2456 116.498 66.0029V50.2529C116.498 49.0103 115.491 48.0029 114.248 48.0029Z"
      fill="#F9F9F9"
      stroke="#29292F"
      strokeLinejoin="round"
    />
    <path
      d="M91.9561 34.958H116.956"
      stroke="#29292F"
    />
    <path
      d="M91.9561 42.6484H116.956"
      stroke="#29292F"
    />
    <path
      d="M91.9561 38.8066H116.956"
      stroke="#29292F"
    />
  </svg>
);
const SvgCloneBased = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgCloneBased;
